import { render, staticRenderFns } from "./UnitRepresentativeDetailsPage.vue?vue&type=template&id=24a25326&"
import script from "./UnitRepresentativeDetailsPage.vue?vue&type=script&lang=ts&"
export * from "./UnitRepresentativeDetailsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24a25326')) {
      api.createRecord('24a25326', component.options)
    } else {
      api.reload('24a25326', component.options)
    }
    module.hot.accept("./UnitRepresentativeDetailsPage.vue?vue&type=template&id=24a25326&", function () {
      api.rerender('24a25326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/UnitRepresentative/UnitRepresentativeDetailsPage.vue"
export default component.exports